(function () {
  var mobileQuery = window.matchMedia("(max-width: 959px)");
  var carouselSelector = ".product__media-container.below-mobile.carousel";
  var videoSlideSelector = ".product__media-item[data-media-type='video']";
  var observers = new WeakMap();

  function prepareVideo(video) {
    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.playsInline = true;
    video.preload = "auto";
    video.setAttribute("muted", "");
    video.setAttribute("autoplay", "");
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
    video.setAttribute("preload", "auto");
  }

  function playVideo(video) {
    if (!video) return;
    prepareVideo(video);

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(function () {});
    }
  }

  function pauseOtherVideos(activeVideo) {
    document.querySelectorAll(carouselSelector + " video").forEach(function (video) {
      if (video !== activeVideo) {
        video.pause();
      }
    });
  }

  function getVisibleVideoSlide(carousel) {
    var carouselRect = carousel.getBoundingClientRect();
    var bestSlide = null;
    var bestVisibleArea = 0;

    carousel.querySelectorAll(videoSlideSelector).forEach(function (slide) {
      var rect = slide.getBoundingClientRect();
      var visibleWidth = Math.min(rect.right, carouselRect.right) - Math.max(rect.left, carouselRect.left);
      var visibleHeight = Math.min(rect.bottom, carouselRect.bottom) - Math.max(rect.top, carouselRect.top);
      var visibleArea = Math.max(0, visibleWidth) * Math.max(0, visibleHeight);

      if (visibleArea > bestVisibleArea) {
        bestVisibleArea = visibleArea;
        bestSlide = slide;
      }
    });

    return bestVisibleArea > 0 ? bestSlide : null;
  }

  function playVisibleCarouselVideo(carousel) {
    if (!mobileQuery.matches || !carousel) return;

    carousel.querySelectorAll("video").forEach(prepareVideo);

    var visibleVideoSlide = getVisibleVideoSlide(carousel);
    if (!visibleVideoSlide) return;

    var video = visibleVideoSlide.querySelector("video");
    pauseOtherVideos(video);
    playVideo(video);
  }

  function bindVideoEvents(carousel) {
    carousel.querySelectorAll("video").forEach(function (video) {
      if (video.dataset.mobileAutoplayBound === "true") return;

      video.dataset.mobileAutoplayBound = "true";
      prepareVideo(video);

      ["loadedmetadata", "loadeddata", "canplay", "canplaythrough"].forEach(function (eventName) {
        video.addEventListener(eventName, function () {
          playVisibleCarouselVideo(carousel);
        });
      });
    });
  }

  function observeCarousel(carousel) {
    if (observers.has(carousel)) return;

    bindVideoEvents(carousel);

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.45) {
            var video = entry.target.querySelector("video");
            pauseOtherVideos(video);
            playVideo(video);
          }
        });
      },
      {
        root: carousel,
        threshold: [0, 0.25, 0.45, 0.65, 1],
      }
    );

    carousel.querySelectorAll(videoSlideSelector).forEach(function (slide) {
      observer.observe(slide);
    });

    observers.set(carousel, observer);
  }

  function autoplayProductVideos(root) {
    if (!mobileQuery.matches) return;

    (root || document).querySelectorAll(carouselSelector).forEach(function (carousel) {
      observeCarousel(carousel);
      playVisibleCarouselVideo(carousel);
    });
  }

  function scheduleAutoplay(root) {
    requestAnimationFrame(function () {
      autoplayProductVideos(root);
      window.setTimeout(function () {
        autoplayProductVideos(root);
      }, 250);
      window.setTimeout(function () {
        autoplayProductVideos(root);
      }, 1000);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    scheduleAutoplay(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    scheduleAutoplay(event.target);
  });

  document.addEventListener("quickview:loaded", function () {
    scheduleAutoplay(document);
  });

  ["touchstart", "touchmove", "touchend", "click", "transitionend"].forEach(function (eventName) {
    document.addEventListener(
      eventName,
      function (event) {
        var carousel = event.target.closest && event.target.closest(carouselSelector);
        if (carousel) {
          scheduleAutoplay(carousel.parentElement || carousel);
        }
      },
      true
    );
  });

  var mutationObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      var target = mutation.target;
      var carousel =
        target.matches && target.matches(carouselSelector)
          ? target
          : target.closest && target.closest(carouselSelector);

      if (carousel) {
        bindVideoEvents(carousel);
        scheduleAutoplay(carousel.parentElement || carousel);
      }
    });
  });

  mutationObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class", "style", "data-is-featured"],
  });

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener("change", function () {
      scheduleAutoplay(document);
    });
  }
})();
